import { render, staticRenderFns } from "./OctMaculaView.vue?vue&type=template&id=157248b4"
import script from "./OctMaculaView.vue?vue&type=script&lang=js"
export * from "./OctMaculaView.vue?vue&type=script&lang=js"
import style0 from "./OctMaculaView.vue?vue&type=style&index=0&id=157248b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports